export default __webpack_public_path__ + "static/3-c9de52c8b2b0493ec81577a1289549b7.png";